import COS from 'cos-js-sdk-v5';
import _axios from './axiosCommon';

const Bucket = 'scratch-1256154465';  /* 存储桶，必须字段 */

const Region = 'ap-shanghai';     /* 存储桶所在地域，必须字段 */


// 初始化实例
const cos = new COS({
    // getAuthorization 必选参数
    getAuthorization: function (options, callback) {
        // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
        // 异步获取临时密钥
        // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
        // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
        // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048

        _axios.post("/scratch/getTempCosCredential").then(res => {
            console.log(res)
            if (!res || !res.data.credential) {
                return console.error('credential invalid:\n' + JSON.stringify(res, null, 2))
            }
            const credential = res.data.credential
            const Credentials = credential.credentials

            callback({
                TmpSecretId: Credentials.tmpSecretId,
                TmpSecretKey: Credentials.tmpSecretKey,
                SecurityToken: Credentials.sessionToken,
                // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                StartTime: credential.startTime, // 时间戳，单位秒，如：1580000000
                ExpiredTime: credential.expiredTime, // 时间戳，单位秒，如：1580000000
            });
        })
    }
});
function doesObjectExist(objectKey, callback) {
    cos.headObject({
        Bucket: Bucket, /* 填入您自己的存储桶，必须字段 */
        Region: Region,  /* 存储桶所在地域，例如ap-beijing，必须字段 */
        Key: `/static/${objectKey}`,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
    }, callback);
    // function (err, data) {
    //     if (data) {
    //         console.log('对象存在');
    //     } else if (err.statusCode == 404) {
    //         console.log('对象不存在');
    //     } else if (err.statusCode == 403) {
    //         console.log('没有该对象读权限');
    //     }
    // }
}
function uploadAsset(objectKey, assest, callback) {
    var body = new Blob([assest.data], { type: assest.assetType.contentType });
    cos.putObject({
        Bucket: Bucket, /* 填入您自己的存储桶，必须字段 */
        Region: Region,  /* 存储桶所在地域，例如ap-beijing，必须字段 */
        Key: `/static/${objectKey}`,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
        Body: body, /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */
        // onProgress: function (progressData) {//上传进度
        //     // console.log(JSON.stringify(progressData));
        // }
    }, callback);
}

function uploadProject(objectKey, jsonStr, callback) {
    cos.putObject({
        Bucket: Bucket,
        Region: Region,
        Key: `/static/project/${objectKey}`,
        Headers: { 'Cache-Control': 'no-cache' },
        Body: jsonStr,
        // onProgress: function (progressData) {//上传进度
        //     // console.log(JSON.stringify(progressData));
        // }
    }, callback);
}

function uploadCover(objectKey, cover, callback) {
    cos.putObject({
        Bucket: Bucket,
        Region: Region,
        Key: `/static/${objectKey}`,
        Body: cover,
        // onProgress: function (progressData) {//上传进度
        //     // console.log(JSON.stringify(progressData));
        // }
    }, callback);
}

export {
    cos as default,
    Bucket, Region,
    doesObjectExist,
    uploadAsset,
    uploadProject,
    uploadCover
}
